module.exports = __webpack_public_path__ + "img/ic_mic_class.03df7cd1.svg";